module.exports = __webpack_public_path__ + "img/cross_btn.302d5770.svg";